import axios from 'axios'

var globalConfig = webConfig;// eslint-disable-line no-undef

var mayRest = function (config) {

    if (typeof config === 'string')
        this._config = {
            service: config
        }
    else {
        this._config = {
            service: null,//服务名称
            dataFilter: null
        }

        if (config) {
            if (config.service)
                this._config.service = config.service;
            if (config.dataFilter)
                this._config.dataFilter = config.dataFilter;
        }
    }

    this._init();
}

mayRest.prototype._init = function () {

    var _this = this;

    var instance //最终返回的实例
    //初始化axios实例

    instance = axios.create({
        baseURL: this._getBaseUrl(),
        timeout: 20000,
        //headers: { 'Accept': 'application/json, text/plain, */*', 'Content-Type': 'application/json;charset=UTF-8' }
    })

    // 添加请求拦截器
    instance.interceptors.request.use(function (config) {

        // 在发送请求之前做些什么
        if (config.params == undefined)
            config.params = {}

        if (globalConfig.accessToken != undefined) {
            config.headers['token'] = globalConfig.accessToken

        }
        //加个时间戳清缓存
        config.params.timestamp = new Date().getTime();
        // config.headers['Content-Type'] = 'application/json'
        return config;
    }, function (error) {
        // 对请求错误做些什么
        return Promise.reject(error);
    })

    // 添加响应拦截器
    instance.interceptors.response.use(function (response) {
        // 对响应数据做点什么
        // console.log(response.data);
        //  console.log(response.status);
        //console.log(response.statusText);
        // console.log(response.headers);
        //console.log(response.config);
        /* if (response.data.code != 1) {
             if (layer != undefined)
                 layer.msg(response.data.msg)
             return Promise.reject(response.data);
         }*/
        if (response.data.Msg != undefined && response.data.Msg != null) {
            // layer.msg(response.data.Msg)
        }
        console.log(response);

        if (response.data.Code == 0) {
            globalConfig.vm.$message.error(response.data.Message);
            return Promise.reject(response.data);
        }

        if (_this._config.dataFilter && typeof _this._config.dataFilter == 'function') {
            response.data = _this._config.dataFilter(response.data);
        }

        return response.data;
    }, function (error) {
        // 对响应错误做点什么

        if (error.response) {
            // 请求已发出，但服务器响应的状态码不在 2xx 范围内
            // console.log(error.response.data);
            //console.log(error.response.status);
            // console.log(error.response.headers);
            console.error(error.response.data);
            console.error(error.response);
        } else {
            // Something happened in setting up the request that triggered an Error
            console.error('Error', error.message);
            console.error(error.config);
        }

        showError(error);

        return Promise.reject(error);
    })




    //显示错误信息
    function showError(error) {
        var message = '';
        if (error.response && error.response.status == 500)
            message = error.response.data.Message;
        else
            switch (error.message) {
                case 'Network Error':
                    message = '发生网络错误！'
                    break;

                default:
                    if (error.message.indexOf("timeout of") != -1)
                        message = '请求超时！'
                    else message = error.message;
                    break;
            }
        console.error(message);
        globalConfig.vm.$message.error(message);
    }

    //代理axios方法
    this.instance = instance;
    this.request = instance.request;
    this.put = instance.put;
    this.post = instance.post;
    this.get = instance.get;
    this.delete = instance.delete;
    this.head = instance.head;
    this.patch = instance.patch;
}

//获取基础url，该函数会获取配置文件lt-config.js里QmConfig.baseURL作为根路径，如果有模块路径，也会加上模块路径
mayRest.prototype._getBaseUrl = function () {
    if (globalConfig == undefined) {
        console.error("缺少配置文件web-config.js");
        return
    }

    if (!globalConfig.baseURL) {
        globalConfig.baseURL = window.location.protocol + "//" + window.location.hostname;
    }

    if (!globalConfig.port || (globalConfig.port && globalConfig.port == '')) {
        globalConfig.port = window.location.port;
    }

    var baseURL = globalConfig.baseURL + ":" + globalConfig.port;

    if (!isURL(baseURL)) {
        console.error('globalConfig.baseURL不是有效的url！')
        return
    }

    if (baseURL.indexOf('http') == -1) {//不以http开头，要补上
        baseURL = "http://" + baseURL;
    }

    if (baseURL[baseURL.length] != '/')//不以/结尾要补上
        baseURL += '/';

    if (this._config.service) {//有配置模块属性，要加上

        baseURL += this._config.service + '/';
    }

    return baseURL

    //判断是否正确的url格式
    function isURL(str_url) {
        var strRegex = '^((https|http|ftp|rtsp|mms)?://)'
            + '?(([0-9a-z_!~*\'().&=+$%-]+: )?[0-9a-z_!~*\'().&=+$%-]+@)?' //ftp的user@ 
            + '(([0-9]{1,3}.){3}[0-9]{1,3}' // IP形式的URL- 199.194.52.184 
            + '|' // 允许IP和DOMAIN（域名） 
            + '([0-9a-z_!~*\'()-]+.)*' // 域名- www. 
            + '([0-9a-z][0-9a-z-]{0,61})?[0-9a-z].' // 二级域名 
            + '[a-z]{2,6})' // first level domain- .com or .museum 
            + '(:[0-9]{1,4})?' // 端口- :80 
            + '((/?)|' // a slash isn't required if there is no file name 
            + '(/[0-9a-z_!~*\'().;?:@&=+$,%#-]+)+/?)$';
        var re = new RegExp(strRegex);
        //re.test() 
        if (re.test(str_url)) {
            return true;
        } else {
            return false;
        }
    }
}


mayRest.all = axios.all;
mayRest.spread = axios.spread;

export default mayRest;